import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TextFieldComponent } from './text-field.component';
import { SvgIconModule } from '../svg-icon/svg-icon.module';
import { TextMaskDirective } from './text-mask.directive';
import { LocalizationModule } from '../localization/localization.module';

@NgModule({
  imports: [CommonModule, SvgIconModule, LocalizationModule],
  declarations: [TextFieldComponent, TextMaskDirective],
  exports: [TextFieldComponent, TextMaskDirective]
})
export class TextFieldModule {}
